import { requestInterceptors } from 'app/services/api/interceptors/request';
import { responseInterceptors } from 'app/services/api/interceptors/response';
import axios from 'axios';
import config from 'config/config';

export const apiService = axios.create({
  baseURL: config.apiEndPoint,
});

requestInterceptors.forEach((requestInterceptor) => {
  apiService.interceptors.request.use(requestInterceptor);
});

responseInterceptors.forEach(({ onFulfilled, onRejected }) => {
  apiService.interceptors.response.use(onFulfilled, onRejected);
});
